<script lang="ts" setup>
import { computed } from 'vue-demi';
import type { Component as VueComponent } from 'vue-demi';
import Network from '@pet/base.icons/network.svg.vue';
import Protect from '@pet/base.icons/protect.svg.vue';
import Band from '@pet/base.icons/band.svg.vue';
import Empty from '@pet/base.icons/empty.svg.vue';
import Anomaly from '@pet/base.icons/anomaly.svg.vue';
import NotStart from '@pet/base.icons/notstart.svg.vue';
import End from '@pet/base.icons/end.svg.vue';
import Download from '@pet/base.icons/download.svg.vue';
import NoBody from '@pet/base.icons/nobody.svg.vue';
import NoGift from '@pet/base.icons/nogift.svg.vue';
import NoMessage from '@pet/base.icons/nomessage.svg.vue';
import ActivityHot from '@pet/base.icons/activityhot.svg.vue';
import User from '@pet/base.icons/user.svg.vue';
import type { IconName, IconSize } from './types';

type Icons<T extends PropertyKey> = {
    [code in T]: VueComponent;
};

const iconComponents: Icons<IconName> = {
    network: Network,
    protect: Protect,
    band: Band,
    empty: Empty,
    anomaly: Anomaly,
    notStart: NotStart,
    end: End,
    download: Download,
    noBody: NoBody,
    noGift: NoGift,
    noMessage: NoMessage,
    activityHot: ActivityHot,
    user: User,
};

interface IconProps {
    /**
     * icon 名称
     */
    name?: IconName;
    /**
     * icon 大小
     */
    size?: IconSize;
}
const props = withDefaults(defineProps<IconProps>(), {
    name: 'network',
    size: 'small',
});

const icon = computed(() => iconComponents[props.name]);
const iconSize = computed(() => `icon-size-${props.size}`);
</script>

<template>
    <component :is="icon" :class="iconSize" />
</template>

<style lang="stylus" scoped>
$full-size = 96px
$small-size = 88px

.icon-size-small
    width $small-size
    height $small-size
.icon-size-large
    width $full-size
    height $full-size
</style>
